import {styled} from '@mui/material/styles';
import {Button} from "@mui/material";

/**
 * A 'fixed' box that covers the entire screen
 */
const OverlayButton = styled(Button)(({theme}) => ({
    backgroundColor: "#222",
    border: "1px solid #fff",
    color: "#fff",
    "&:hover, &:active": {
        boxShadow: "none",
    }
}));

export {OverlayButton}